import { Config } from './helpers/extensions';

export const DEFAULT_PLACEHOLDER = 'Write your content…';
export const UPLOAD_ALERT = 'Navigating away will cancel your currently uploading file.';
export const SAVE_DEBOUNCE = 1000;
export const BASE_CONFIG: Partial<Config> = {
  headings: true
};
